import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';
import { intlReducer, IntlState } from 'react-intl-redux';
import { combineReducers, createStore as _createStore, Dispatch, MiddlewareAPI, Store } from 'redux';

import { collectionReducer, CollectionState } from './collection';
import { KeycloakState, keycloakReducer } from './keycloak';
import { localesReducer, LocalesState } from './locales';
import { LocationState, locationReducer } from './location';
import createMiddleware from './middlewares';
import { UIState, uiReducer } from './ui';

export interface AppState {
    collection: CollectionState;
    intl: IntlState;
    keycloak: KeycloakState;
    locales: LocalesState;
    location: LocationState;
    router: RouterState;
    ui: UIState;
}

export type MainStore = MiddlewareAPI<Dispatch, AppState>;

function createRootReducer(history: History) {
    return combineReducers<AppState>({
        collection: collectionReducer,
        intl: intlReducer,
        keycloak: keycloakReducer,
        locales: localesReducer,
        location: locationReducer,
        router: connectRouter(history),
        ui: uiReducer,
    });
}

export default function createStore(history: History, initialState = {}): Store {
    return _createStore(createRootReducer(history), initialState, createMiddleware(history));
}
